var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isBase64)?_c('div',[_c('img',{class:_vm.customClass,attrs:{"src":_vm.document,"alt":"img"}})]):_c('div',[_c('img',{class:_vm.customClass,attrs:{"src":_vm.temporaryLinkUri,"alt":"img"}})])}
var staticRenderFns = []

export { render, staticRenderFns }